export default __webpack_public_path__ + "media/images/features/saga/arita_yaki-4a9e589b64b40525a1cd243adeea79af.jpg";